import {
    ReachElement,
    ReachElementsAndErrors,
    SET_EDITING_REACH_ELEMENTS,
    SET_REACH_ELEMENTS_AND_ERRORS,
    SET_GENERAL_VALIDATION_ERRORS
} from "./types";

export function setEditingReachElements(elements: Array<ReachElement>) {
    return {
        type: SET_EDITING_REACH_ELEMENTS,
        payload: elements
    };
}

export function setGeneralValidationsErrors(errors: string[]) {
    return {
        type: SET_GENERAL_VALIDATION_ERRORS,
        payload: errors
    };
}

export function setReachElementsAndErrors(elementsAndErrors: ReachElementsAndErrors) {
    return {
        type: SET_REACH_ELEMENTS_AND_ERRORS,
        payload: elementsAndErrors
    };
}